module.exports = __webpack_public_path__ + "static/media/BR.55640782.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BR.svg
// module id = 210
// module chunks = 0